import { Marker } from 'react-map-gl';
import {
  Box,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import { FloatingOutlet } from '../FloatingOutlet';
import { MarkerIconSVG } from './MarkerIconSVG';

interface Props {
  outlet: AdaptedStore;
}

export type OutletMarkerProps = Props;

export const OutletMarker = (props: Props) => {
  const { outlet } = props;

  if (!outlet.address.geometry) return null;

  return (
    <Popover>
      <Marker
        latitude={outlet.address.geometry?.lat}
        longitude={outlet.address.geometry?.lon}
      >
        <PopoverTrigger>
          <Box>
            <MarkerIconSVG />
          </Box>
        </PopoverTrigger>
      </Marker>

      <PopoverContent
        rounded="lg"
        border="none"
        _focusVisible={{ border: 'none', outline: 0 }}
      >
        <PopoverArrow />

        <FloatingOutlet outlet={outlet} />
      </PopoverContent>
    </Popover>
  );
};
